import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./SchoolSidebar.css";

export default function SchoolSidebar() {
  const location = useLocation();
  const school = JSON.parse(localStorage.getItem("schoolAdmin"))?.school;
  const [openSection, setOpenSection] = useState(null);

  const sections = [
    {
      title: "Dashboard", icon: "🏠", alwaysOpen: true,
      items: [{ name: "Home", path: "/school-admin/dashboard" }],
    },
    {
      title: "Students", icon: "🎓",
      items: [
        { name: "Students",   path: "/school-admin/students" },
        { name: "Add Student", path: "/school-admin/students/add" },
        { name: "Complaints", path: "/school-admin/complaints" },
      ],
    },
    {
      title: "Classes & Sections", icon: "🏫",
      items: [
        { name: "Classes",          path: "/school-admin/classes" },
        { name: "Add Class",        path: "/school-admin/classes/add" },
        { name: "Sections",         path: "/school-admin/sections" },
        { name: "Add Section",      path: "/school-admin/sections/add" },
        { name: "Subjects",         path: "/school-admin/subjects" },
        { name: "Add Subject",      path: "/school-admin/subjects/add" },
        { name: "Archived Classes", path: "/school-admin/classes/archived" },
      ],
    },
    {
      title: "Teachers", icon: "👩‍🏫",
      items: [
        { name: "Teacher List",        path: "/school-admin/teachers" },
        { name: "Add Teacher",         path: "/school-admin/teachers/add" },
        { name: "Archived Teachers",   path: "/school-admin/teachers/archived" },
        { name: "Attendance",          path: "/school-admin/teacher-attendance" },
        { name: "Leave Approval",      path: "/school-admin/teacher-leaves" },
        { name: "Attendance Calendar", path: "/school-admin/teacher-attendance/calendar" },
        { name: "Salary Dashboard",    path: "/school-admin/salary" },
        { name: "Generate Salary",     path: "/school-admin/salary/generate" },
        { name: "Pending Salaries",    path: "/school-admin/salary/pending" },
        { name: "Paid Salaries",       path: "/school-admin/salary/paid" },
      ],
    },
    {
      title: "Fees", icon: "💳",
      items: [
        { name: "Fees Dashboard",  path: "/school-admin/fees" },
        { name: "Fees List",       path: "/school-admin/addon-fees" },
        { name: "Add Fee",         path: "/school-admin/addon-fees/add" },
        { name: "Invoice Settings",path: "/school-admin/invoice-settings" },
        { name: "Invoices",        path: "/school-admin/invoices" },
      ],
    },
    {
      title: "Academics", icon: "📝",
      items: [
        { name: "Exams",         path: "/school-admin/exams" },
        { name: "Add Exam",      path: "/school-admin/exams/add" },
        { name: "Archived Exams",path: "/school-admin/exams/archived" },
        { name: "Class Tests",   path: "/school-admin/class-tests" },
      ],
    },
    {
      title: "Results", icon: "📊",
      items: [
        { name: "Upload File",    path: "/school-admin/results/upload-file" },
        { name: "Upload Excel",   path: "/school-admin/results/upload-excel" },
        { name: "Student Results",path: "/school-admin/results/files" },
      ],
    },
    {
      title: "Timetable", icon: "🗓️",
      items: [
        { name: "Timetable",        path: "/school-admin/timetable" },
        { name: "Weekly Timetable", path: "/school-admin/timetable/weekly" },
      ],
    },
    {
      title: "Staff", icon: "👥",
      items: [
        { name: "Staff List",    path: "/school-admin/staff" },
        { name: "Add Staff",     path: "/school-admin/staff/add" },
        { name: "Staff Salary",  path: "/school-admin/staff/salary" },
        { name: "Archived Staff",path: "/school-admin/staff/archived" },
      ],
    },
    {
      title: "Finance", icon: "💰",
      items: [
        { name: "Expense Tracker", path: "/school-admin/expense" },
        { name: "Add Expense",     path: "/school-admin/expense/add" },
      ],
    },
    {
      title: "Events & Notices", icon: "📢",
      items: [
        { name: "Events",  path: "/school-admin/events" },
        { name: "Notices", path: "/school-admin/notices" },
      ],
    },
    {
      title: "Library", icon: "📚",
      items: [
        { name: "Dashboard",     path: "/school-admin/library" },
        { name: "Categories",    path: "/school-admin/library/categories" },
        { name: "Add Category",  path: "/school-admin/library/categories/add" },
        { name: "Books",         path: "/school-admin/library/books" },
        { name: "Add Book",      path: "/school-admin/library/books/add" },
        { name: "Issue Book",    path: "/school-admin/library/issue" },
        { name: "Return Book",   path: "/school-admin/library/return" },
        { name: "Question Papers",path: "/school-admin/settings/gallery" },
      ],
    },
    {
      title: "Hostel", icon: "🏠",
      items: [
        { name: "Hostels",          path: "/school-admin/hostels" },
        { name: "Add Hostel",       path: "/school-admin/hostels/add" },
        { name: "Allocate Student", path: "/school-admin/hostels/allocate" },
      ],
    },
    {
      title: "Transport", icon: "🚌",
      items: [
        { name: "Bus Management", path: "/school-admin/transport/buses" },
      ],
    },
    {
      title: "Inventory", icon: "📦",
      items: [
        { name: "Items",        path: "/school-admin/inventory" },
        { name: "Add Item",     path: "/school-admin/inventory/add" },
        { name: "Categories",   path: "/school-admin/inventory/categories" },
        { name: "Add Category", path: "/school-admin/inventory/categories/add" },
        { name: "Orders",       path: "/school-admin/orders" },
      ],
    },
    {
      title: "Career Guide", icon: "🎯",
      items: [
        { name: "Courses",    path: "/school-admin/career" },
        { name: "Add Course", path: "/school-admin/career/add" },
      ],
    },
    {
      title: "Calendar", icon: "📅",
      items: [
        { name: "Holidays",    path: "/school-admin/holidays" },
        { name: "Add Holiday", path: "/school-admin/holidays/add" },
      ],
    },
    {
      title: "School Pages", icon: "🔒",
      items: [
        { name: "About School",      path: "/school-admin/settings/pages?type=about" },
        { name: "Terms & Conditions",path: "/school-admin/settings/pages?type=terms" },
        { name: "Privacy Policy",    path: "/school-admin/settings/pages?type=privacy" },
        { name: "Contact Us",        path: "/school-admin/settings/pages?type=contact" },
      ],
    },
  ];

  // Auto-open section based on current route
  useEffect(() => {
    sections.forEach((section) => {
      section.items.forEach((item) => {
        if (location.pathname.startsWith(item.path)) {
          setOpenSection(section.title);
        }
      });
    });
  }, [location.pathname]);

  return (
    <div className="school-sidebar-container">

      {/* HEADER */}
      <div className="sb-header">
        <div className="sb-school-row">
          <div className="sb-school-avatar">🏫</div>
          <div className="sb-school-info">
            <h3>{school?.name || "School Admin"}</h3>
            <p>{school?.subdomain}.navith.cloud</p>
          </div>
        </div>
        <div className="sb-label">Admin Panel</div>
      </div>

      {/* SCROLL */}
      <div className="sidebar-scroll">
        {sections.map((section) => {
          const isOpen = section.alwaysOpen || openSection === section.title;

          return (
            <div key={section.title} className="sidebar-section">

              {/* SECTION HEADER */}
              <div
                className={`sidebar-section-title${isOpen ? " open" : ""}`}
                onClick={() =>
                  !section.alwaysOpen &&
                  setOpenSection(isOpen ? null : section.title)
                }
              >
                <span className="sb-sec-icon">{section.icon}</span>
                <span className="sb-sec-label">{section.title}</span>
                {!section.alwaysOpen && (
                  <span className="sb-arrow">▶</span>
                )}
              </div>

              {/* ITEMS */}
              {isOpen && (
                <ul className="school-sidebar-menu">
                  {section.items.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`school-sidebar-link${
                          location.pathname.startsWith(item.path) ? " active" : ""
                        }`}
                      >
                        <span className="sb-link-dot" />
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}

              <div className="sidebar-divider" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
